/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Settings_About_TitleInputs */

const en_ui_settings_about_title = /** @type {(inputs: Ui_Settings_About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About PaceVault`)
};

const de_ui_settings_about_title = /** @type {(inputs: Ui_Settings_About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über PaceVault`)
};

/**
* | output |
* | --- |
* | "About PaceVault" |
*
* @param {Ui_Settings_About_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_settings_about_title = /** @type {((inputs?: Ui_Settings_About_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Settings_About_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_settings_about_title(inputs)
	return de_ui_settings_about_title(inputs)
});